/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Product card variant selector for size swatches
  // This function must be in global scope for Alpine.js to access it
  if (typeof window !== 'undefined') {
    window.productCardVariantData = function (initialVariantId) {
      return {
        selectedVariantId: parseInt(initialVariantId),
        init() {
          this.$nextTick(() => {
            const formInputs = this.$el.querySelectorAll('.new-arrivals-card__add-to-bag-form input[name="id"]');
            formInputs.forEach(input => {
              input.value = this.selectedVariantId;
            });
          });
        },
        selectVariant(variantId) {
          variantId = parseInt(variantId);
          this.selectedVariantId = variantId;
          const formInputs = this.$el.querySelectorAll('.new-arrivals-card__add-to-bag-form input[name="id"]');
          formInputs.forEach(input => {
            input.value = variantId;
          });
        }
      };
    };
  }

  // Handle size swatch selection for product cards
  // Use event delegation to handle clicks on size swatches (works for dynamically loaded content)
  function handleSizeSwatchClick(e) {
    // Check if clicked element or its parent is a size swatch
    let sizeSwatch = e.target.closest('.new-arrivals-card__size-swatch');

    // If clicking directly on the button, use the target
    if (!sizeSwatch && e.target.classList.contains('new-arrivals-card__size-swatch')) {
      sizeSwatch = e.target;
    }

    if (!sizeSwatch) return;

    // Check if disabled
    if (sizeSwatch.disabled || sizeSwatch.classList.contains('new-arrivals-card__size-swatch--unavailable')) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const variantId = sizeSwatch.getAttribute('data-variant-id') || sizeSwatch.dataset.variantId;
    if (!variantId) {
      console.warn('Size swatch clicked but no variant ID found', sizeSwatch);
      return;
    }

    // Get the product card container
    const productCard = sizeSwatch.closest('.new-arrivals-card');
    if (!productCard) {
      console.warn('Size swatch clicked but product card not found');
      return;
    }

    // Remove active class from all size swatches in this card
    const allSwatches = productCard.querySelectorAll('.new-arrivals-card__size-swatch');
    allSwatches.forEach(swatch => {
      swatch.classList.remove('new-arrivals-card__size-swatch--active');
    });

    // Add active class to clicked swatch
    sizeSwatch.classList.add('new-arrivals-card__size-swatch--active');

    // Update the variant ID in the add to cart form
    const formInputs = productCard.querySelectorAll('.new-arrivals-card__add-to-bag-form input[name="id"]');
    if (formInputs.length > 0) {
      formInputs.forEach(input => {
        input.value = variantId;
      });
      // console.log('Variant updated to:', variantId);

      // Update button data attributes and check cart status
      const button = productCard.querySelector('.new-arrivals-card__add-to-bag-btn[data-add-to-cart]');
      if (button) {
        button.dataset.variantId = variantId;
        // Get max quantity from the size swatch
        const maxQuantity = sizeSwatch.dataset.maxQuantity || '40';
        button.dataset.maxQuantity = maxQuantity;
        // Check cart status for this variant
        checkVariantCartStatus(button, variantId, parseInt(maxQuantity));
      }
    } else {
      // Form might not exist yet (e.g., if hover effect is disabled)
      // Store the variant ID in a data attribute on the card for later use
      productCard.setAttribute('data-selected-variant-id', variantId);
      // console.log('Variant stored in data attribute:', variantId);
    }
  }

  /**
   * Checks if a variant is in cart and at max quantity, updates button accordingly
   */
  function checkVariantCartStatus(button, variantId, maxQuantity) {
    if (!maxQuantity) {
      maxQuantity = parseInt(button.dataset.maxQuantity) || 40;
    }
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartItem = cart.items.find(item => item.variant_id === parseInt(variantId));
        const cartQuantity = cartItem ? cartItem.quantity : 0;
        const isAtMax = cartQuantity >= maxQuantity;

        if (isAtMax && cartQuantity > 0) {
          button.textContent = 'Already in Cart';
          button.setAttribute('aria-label', 'Already in cart');
          button.classList.add('new-arrivals-card__add-to-bag-btn--in-cart');
          button.disabled = true;
        } else {
          button.textContent = 'Add to Bag';
          button.setAttribute('aria-label', 'Add to bag');
          button.classList.remove('new-arrivals-card__add-to-bag-btn--in-cart');
          button.disabled = false;
        }
      })
      .catch(error => {
        console.error('Error checking variant cart status:', error);
      });
  }

  // Attach event listener when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.addEventListener('click', handleSizeSwatchClick, true);
      setupProductCardAddToBag();
      setupProductCardCartStatus();
    });
  } else {
    // DOM is already loaded
    document.addEventListener('click', handleSizeSwatchClick, true);
    setupProductCardAddToBag();
    setupProductCardCartStatus();
  }

  /**
   * Sets up event listeners to prevent popdown and open cart drawer for product card "Add to Bag" buttons
   */
  function setupProductCardAddToBag() {
    // Track if the add to bag came from a product card
    let isProductCardAdd = false;

    // Listen for clicks on product card add to bag buttons
    document.addEventListener('click', function (e) {
      const button = e.target.closest('.new-arrivals-card__add-to-bag-btn[data-add-to-cart]');
      if (button && button.closest('.new-arrivals-card__add-to-bag-form')) {
        isProductCardAdd = true;
        // Reset flag after 3 seconds (enough time for the cart change event)
        setTimeout(function () {
          isProductCardAdd = false;
        }, 3000);
      }
    }, true);

    // Prevent popdown from opening when adding from product cards
    // Use capture phase to intercept before the popdown handler
    document.addEventListener('theme:cart:popdown', function (e) {
      if (isProductCardAdd) {
        // Prevent the popdown from opening
        e.stopImmediatePropagation();
        e.preventDefault();

        // Close popdown if it's already open
        const popdownElement = document.querySelector('[data-product-add-popdown-wrapper]');
        if (popdownElement) {
          popdownElement.classList.remove('is-visible');
        }
      }
    }, true); // Use capture phase to intercept before other handlers

    // Listen for cart changes and open cart drawer for product card additions
    document.addEventListener('theme:cart:change', function (event) {
      if (isProductCardAdd) {
        // Check if we're on cart page (don't open drawer there)
        const isOnCartPage = document.getElementById('shopify-section-custom-cart-page');
        if (!isOnCartPage) {
          // Open the custom cart drawer
          if (typeof window.openCartDrawer === 'function') {
            setTimeout(function () {
              window.openCartDrawer();
            }, 150);
          }
        }
      }
    });
  }

  /**
   * Updates product card button text based on cart status
   * Checks if variants are in cart and at max quantity
   */
  function setupProductCardCartStatus() {
    function updateProductCardButtons() {
      // Get current cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Create a map of variant IDs to quantities
          const variantQuantities = {};
          cart.items.forEach(item => {
            variantQuantities[item.variant_id] = item.quantity;
          });

          // Update all product card buttons
          const buttons = document.querySelectorAll('.new-arrivals-card__add-to-bag-btn[data-variant-id]');
          buttons.forEach(button => {
            const variantId = parseInt(button.dataset.variantId);
            const maxQuantity = parseInt(button.dataset.maxQuantity) || 40;
            const cartQuantity = variantQuantities[variantId] || 0;
            const isAtMax = cartQuantity >= maxQuantity;

            if (isAtMax && cartQuantity > 0) {
              button.textContent = 'Already in Cart';
              button.setAttribute('aria-label', 'Already in cart');
              button.classList.add('new-arrivals-card__add-to-bag-btn--in-cart');
              button.disabled = true;
            } else {
              button.textContent = 'Add to Bag';
              button.setAttribute('aria-label', 'Add to bag');
              button.classList.remove('new-arrivals-card__add-to-bag-btn--in-cart');
              button.disabled = false;
            }
          });
        })
        .catch(error => {
          console.error('Error updating product card buttons:', error);
        });
    }

    // Update buttons on cart changes
    document.addEventListener('theme:cart:change', function () {
      setTimeout(updateProductCardButtons, 200);
    });

    // Update buttons on page load (listen to cart init event to avoid double call)
    document.addEventListener('theme:cart:init', function () {
      setTimeout(updateProductCardButtons, 500);
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
